import * as React from 'react';
import SelectField from '../../common/form-controls/SelectField';
import FieldHandler from '../../../models/interfaces/FieldHandler';
import { Environment } from '../../../models/enums/Environment';
import { authenticatedUser } from '../../../authentication/authModule';
import { UserRole } from '../../../models/enums/UserRole';

interface PlatformManagementGroupInputProps extends FieldHandler<string> { }

interface ManagementGroupInputState {

}

export class PlatformManagementGroupInput extends React.Component<PlatformManagementGroupInputProps,ManagementGroupInputState> {
	render() {
		return (
			<SelectField
				label="Platform Management Group"
				className="full-width"
				options={
					[
						{ text: 'PLATFORMTST', value: 'PLATFORMTST' },
						{ text: 'PLATFORMPRD', value: 'PLATFORMPRD' },
					]
				}
				{...this.props}
			/>
		);
	}
}